import React, { useEffect, useState } from "react";
import Toolbar, { Item } from "devextreme-react/toolbar";
import Button from "devextreme-react/button";
//import UserPanel from "../user-panel/UserPanel";
import "./Header.scss";
//import { Template } from "devextreme-react/core/template";

import { DropDownButton } from "devextreme-react";
import FavoritesBar from "../favorites-bar/FavoritesBar";
import { parsedUser } from "../../utils/GetCurrentUser";

import { useTranslation } from "react-i18next";
import ChangeOrganization from "./ChangeOrganization";
import ClearUser from "../../utils/ClearUser";
import ROUTES from "../../utils/routes";
import { useNavigate } from "react-router-dom";

export default function Header({ menuToggleEnabled, title, toggleMenu, showTitle }) {
  const [user, setUser] = useState(parsedUser());
  const [showBusinessUnits, setShowBusinessUnits] = React.useState(false);
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  // const changeLanguage = (value) => {
  //   localStorage.setItem("lng", value);
  //   i18n.changeLanguage(value);
  // };
  useEffect(() => {
    if (!showBusinessUnits) {
      setUser(parsedUser())
    }
  }
    , [showBusinessUnits])

  // Cargar color del header desde configuración
  const colorHeader = localStorage.getItem('COLOR_HEADER');
  const colorHeader2 = localStorage.getItem('COLOR_HEADER_2');

  return (
    <header className={"header-component"} style={{ backgroundColor: colorHeader }}>
      {showBusinessUnits && <ChangeOrganization show={showBusinessUnits} toggle={() => setShowBusinessUnits(false)} />}
      <Toolbar className={"header-toolbar"}>
        <Item
          visible={menuToggleEnabled}
          location={" "}
          widget={"dxButton"}
          cssClass={"menu-button"}
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>

        {/* Mostrar el título "Signos Framework" cuando showTitle es true */}
        {showTitle && (
          <Item location={"before"} cssClass={"logo-item"}>
            <div className="d-flex align-items-center ms-3 logo">
              <h4>
                Signos Framework
              </h4>
            </div>
          </Item>
        )}

          <Item
            location={"before"}
          >
            <div className="d-flex align-items-center">
              <i className="fa-thin fa-people-roof text-white ms-4 me-3" style={{ fontSize: "24px" }}></i>
              <h5 className="title-4 clickable business-unit-button"
                onClick={() => setShowBusinessUnits(true)}
                style={{ marginBottom: '0px', fontSize: '20px', backgroundColor: colorHeader2 }}
              >
                {user.NameBusinessUnit}
                <i className="fa fa-caret-down ms-2" aria-hidden="true"></i>
              </h5>
            </div>
          </Item>

          <Item location={"before"}>
            <FavoritesBar />
          </Item>
          
        {/* <Item location={"before"}>
        </Item>
        <Item location={"after"} locateInMenu={"auto"}>
          <DropDownButton
            className="language-select"
            icon="fa fa-language"
            text={t("Language")}
            onSelectionChanged={(e) => changeLanguage(e.item.lng)}
            items={[
              { id: 2, text: t("English"), lng: "en" },
              { id: 1, text: t("Spanish"), lng: "es" },
            ]}
          // Configuration goes here
          />
        </Item> */}
        <Item
          location={"after"}
          locateInMenu={"auto"}
          menuItemTemplate={"userPanelTemplate"}
        >
          {/* <Button
            className={"user-button authorization"}
            // width={210}
            height={"100%"}
            stylingMode={"text"}
          >
            <UserPanel menuMode={"context"} />
          </Button> */}

            <div className="d-flex align-items-center" style={{ '--user-btn-color': colorHeader2 }}>
              <i className="fa-thin fa-circle-user text-white me-3" style={{ fontSize: "24px" }}></i>
              <DropDownButton 
                className="user-button-dropdown"
                text={user.Username}
                displayExpr="text"
                keyExpr="id"
                onItemClick={(e) => e.itemData.onClick && e.itemData.onClick()}
                items={[
                  // { id: 1, text: t("Perfil"), icon: "user", onClick: () => navigate("/profile") },
                  { id: 1, text: t("Cambiar Contraseña"), icon: "user", onClick: () => {} },
                  { id: 2, text: t("Cerrar sesión"), icon: "runner", onClick: () => { ClearUser(); window.location = ROUTES.Default.Clean; } }
                ]}
                dropDownOptions={{ width: 210 }}
              />
            </div>
          
        </Item>
        {/* <Template name={"userPanelTemplate"}>
          <UserPanel menuMode={"list"} />
        </Template> */}
      </Toolbar>
    </header>
  );
}
